export default "__VITE_ASSET__BD3ofDfF__"